











import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props, FillType } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    size: {
      type: Number,
      default: 18
    },
    fill: {
      type: String as PropType<Props["fill"]>,
      default: FillType.Filled
    }
  },
  computed: {
    fillName() {
      switch (this.fill) {
        case FillType.Filled:
          return "Star-Filled";
        case FillType.Half:
          return "Star-Half";
        case FillType.Empty:
          return "Star-Empty";
        default:
          return "Star-Filled";
      }
    },
    sizeStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      };
    }
  }
});
